import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import { Dropdown, TextInput, FormContainer } from 'Shared/Components/FormComponents'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import { showSuccess } from 'Shared/Components/NotifyToast'

const EquipmentForm = ({ mode, assets_id, initialState, reload, closemodal }) => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()
  const { setPageLoading } = useOutletContext()

  const [equipmentTypes, setEquipmentTypes] = useState([])

  useEffect(() => {
    const getEquipments = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/assets_tracking/types`,
        returnType: "json"
      })

      body && setEquipmentTypes(body.map((i) => ({
        "value": i["type_id"],
        "label": i["type_name"],
      })))
    }

    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getEquipments()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const onFinish = (value) => {
    const call = async (url, method) => {
      setPageLoading(true)

      const res = await send({
        method: method,
        url: url,
        contentType: "json",
        body: {
          "equipment_name": value["equipment_name"],
          "equipment_description": value["equipment_description"],
          "equipment_type": value["equipment_type"],
          "manufacturer": value["manufacturer"],
          "model": value["model"],
          "remark": value["remark"]
        }
      })

      if (res != null) {
        showSuccess(t("general_success"))
        closemodal()
        await reload()
      }

      setPageLoading(false)
    }

    switch (mode) {
      case "create":
        call(`${apiUrl}/assets_tracking/equipment`, "POST")
        return
      case "edit":
        call(`${apiUrl}/assets_tracking/equipment/${assets_id}`, "PUT")
        return
      default:
        return
    }
  }

  return (<>
    <FormContainer form={form} onFinish={onFinish} initialValues={initialState}>
      <TextInput field_name={t("assetsTracking_equipmentName")} field_id="equipment_name" required />
      <TextInput field_name={t("assetsTracking_equipmentDescription")} field_id="equipment_description" />
      <Dropdown field_name={t("assetsTracking_equipmentType")} field_id="equipment_type" props={{ "options": equipmentTypes }} required />
      <TextInput field_name={t("assetsTracking_manufacturer")} field_id="manufacturer" />
      <TextInput field_name={t("assetsTracking_model")} field_id="model" />
      <TextInput field_name={t("assetsTracking_remark")} field_id="remark" />
    </FormContainer>
  </>)
}

export default EquipmentForm
